// removed by extract-text-webpack-plugin
module.exports = {"profile":"finance_company-profile_profile","narrow":"finance_company-profile_narrow","left":"finance_company-profile_left","description":"finance_company-profile_description","phone":"finance_company-profile_phone","phoneHeader":"finance_company-profile_phoneHeader","bold":"finance_company-profile_bold","dataUnavailable":"finance_company-profile_dataUnavailable","container":"finance_company-profile_container","competitors":"finance_company-profile_competitors","right":"finance_company-profile_right"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/components/company-profile/style.less
// module id = 431
// module chunks = 0